// Help content has no backend (user decision 2026-09-24): everything here is static front-end content from the spec.
// Guide and video pages, with their text, live in helpGuides.ts (/help/guides/:slug, /help/videos/:slug); live chat and
// call booking are still preview only.

export interface Guide { title: string; meta: string; icon: 'megaphone' | 'users' | 'message' | 'play'; video?: boolean }

export const POPULAR_GUIDES: Guide[] = [
    { title: 'Add an ASX announcement and email it', meta: '4 min read · with pictures', icon: 'megaphone' },
    { title: 'Read the holdings movement report', meta: '3 min read', icon: 'users' },
    { title: 'Answer an investor question safely', meta: 'Continuous‑disclosure checklist', icon: 'message' },
    { title: 'Watch: Investi in 10 minutes', meta: 'Video · captions available', icon: 'play', video: true },
];

// guided tours are real (not preview): the list is the tour registry, see tour/tours.ts
export { TOUR_REGISTRY as TOURS } from '../tour/tours';

export interface Topic { title: string; guides: number; description: string; icon: 'home' | 'users' | 'megaphone' | 'mail' | 'globe' | 'shield' }

export const TOPICS: Topic[] = [
    { title: 'Getting started', guides: 8, description: 'Set up a client, invite your team and connect the registry', icon: 'home' },
    { title: 'Share registry', guides: 11, description: 'Search holders, top‑20 changes and movement reports', icon: 'users' },
    { title: 'Announcements', guides: 9, description: 'Add, approve and email ASX announcements', icon: 'megaphone' },
    { title: 'Email campaigns', guides: 14, description: 'Contacts, templates, sending and reports', icon: 'mail' },
    { title: 'Website Hub', guides: 10, description: 'Pages, questions, sign‑ups and social posts', icon: 'globe' },
    { title: 'Account & security', guides: 6, description: 'Passwords, two‑factor and access levels', icon: 'shield' },
];

export const VIDEOS = [
    { title: 'Investi in 10 minutes', length: '9:48' },
    { title: 'Emailing an announcement', length: '3:12' },
    { title: 'Reading a movement report', length: '4:05' },
];

export const POPULAR_SEARCHES = ['Add an announcement', 'Holdings report', 'Answer a question', 'Invite a teammate'];

export const SUPPORT_EMAIL = 'support@investi.com.au';

// "You're on: …" in the help panel, by the first url segment
export const PAGE_NAMES: { [segment: string]: string } = {
    dashboard: 'Dashboard · Overview',
    'share-registry': 'Share Registry',
    communications: 'Communications',
    notifications: 'Notifications',
    account: 'My Account',
    help: 'Help centre',
};
